import React from "react";
import { useHistory } from "react-router-dom";

import { Box, Card, CardActionArea, Typography } from "@mui/material";

import NotificationSettingChannelIcon from "design-system/icons/info/NotificationSettingChannelIcon";
import NotificationItemChip from "./NotificationItemChip";
import NotificationSettingTriggerIcon from "design-system/icons/info/NotificationSettingTriggerIcon";
import { NotificationSetting } from "types";
import { errorRed } from "design-system/colors";

type NotificationSettingItemProps = {
  notificationSetting: NotificationSetting;
  isDisabled: boolean;
};

function NotificationSettingItem(props: NotificationSettingItemProps) {
  const { notificationSetting, isDisabled } = props;

  // hooks
  const history = useHistory();

  // event handler
  const handleNotificationSettingItemClick = () => {
    history.push(`/settings/notifications/update/${notificationSetting.id}`);
  };

  return (
    <Card variant="outlined" sx={{ opacity: isDisabled ? 0.5 : 1 }}>
      <CardActionArea
        onClick={handleNotificationSettingItemClick}
        disableRipple
        disabled={isDisabled}
      >
        <Box p={2}>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="subtitle2">
              {notificationSetting.templateName}
            </Typography>
            <Typography variant="caption" color={errorRed}>
              {isDisabled && "Setting is Disabled"}
            </Typography>
          </Box>

          <Box display="flex" gap={1}>
            <Box maxWidth="470px">
              <NotificationItemChip
                icon={<NotificationSettingTriggerIcon />}
                title="Trigger"
                description={notificationSetting.event?.description || ""}
              />
            </Box>
            <NotificationItemChip
              icon={<NotificationSettingChannelIcon />}
              title="Channels"
              description={notificationSetting.channel}
            />
          </Box>
        </Box>
      </CardActionArea>
    </Card>
  );
}

export default NotificationSettingItem;
